<div class="p-5">
  <div class="flex justify-between items-center">
    <div class="text-lg text-gray-700 font-bold">Progresso do trajeto</div>
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Cabeçalho -->
  <div class="mt-3 grid grid-cols-2 gap-x-6 gap-y-1 text-sm text-gray-700">
    <div><b>TG:</b> {{ item.codigoTg || '-' }}</div>
    <div><b>OS:</b> {{ item.codigoOs || '-' }}</div>
    <div><b>Cliente:</b> {{ item.nomeCliente || '-' }}</div>
    <div><b>Status geral:</b> {{ item.descricaoStatus || '-' }}</div>
    <div><b>Motorista:</b> {{ item.nome || '-' }}</div>
    <div><b>Veículo:</b> {{ item.placa || '-' }}</div>
    <div class="col-span-2"><b>Etapa atual:</b> {{ descricaoAndamento(etapaAtual) }}</div>
  </div>

  @if (faltaRecursoParaIniciar) {
  <div class="mt-3 p-2 rounded bg-yellow-50 text-yellow-800 text-sm">
    Sem motorista e/ou veículo atribuído — a OS não pode ser iniciada.
  </div>
  }

  <!-- Timeline -->
  <div class="mt-5">
    <div class="text-sm font-semibold text-gray-600 mb-2">Histórico</div>
    @if (loadingHistorico) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    } @else if (historico.length === 0) {
    <div class="text-gray-400 text-sm">Nenhuma etapa registrada ainda.</div>
    } @else {
    <div class="timeline">
      @for (h of historico; track h.id) {
      <div class="timeline-item">
        <div class="text-sm">
          <b>{{ h.statusAnterior || '—' }}</b> → <b>{{ h.statusNovo }}</b>
          @if (h.localParada) {
          <span class="text-gray-500"> · {{ h.localParada }}</span>
          }
        </div>
        <div class="text-xs text-gray-500">
          {{ h.dataOcorrido }} {{ h.horaOcorrido }} · {{ h.nomeCriadoPor }}
          @if (registradoOffline(h)) {
          <span class="chip-offline">sincronizado depois</span>
          }
        </div>
        @if (atrasoParada(h)) {
        <div class="text-xs atraso-parada">{{ atrasoParada(h) }}</div>
        }
        @if (h.observacao) {
        <div class="text-xs text-gray-600 italic">{{ h.observacao }}</div>
        }
      </div>
      }
    </div>
    }
  </div>

  <!-- Ações -->
  <div class="mt-5">
    <button mat-flat-button class="btn-tg" [disabled]="proximasEtapas.length === 0 || advancing"
      (click)="avancarEtapa()">
      @if (advancing) {
      <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
      } @else {
      Avançar etapa
      }
    </button>

    <div class="text-sm font-semibold text-gray-600 mt-4 mb-2">Registrar manualmente</div>
    <div [formGroup]="form" class="flex flex-col gap-2">
      <mat-form-field class="input-tg w-full" appearance="outline" hideRequiredMarker>
        <mat-label>Etapa</mat-label>
        <mat-select formControlName="statusId">
          @for (etapa of proximasEtapas; track etapa) {
          <mat-option [value]="etapa">{{ descricaoAndamento(etapa) }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      @if (form.get('statusId')?.value === STATUS_ANDAMENTO_PARADA) {
      <mat-form-field class="input-tg w-full" appearance="outline" hideRequiredMarker>
        <mat-label>Parada</mat-label>
        <mat-select formControlName="itinerarioId">
          @for (parada of paradas; track parada.id) {
          <mat-option [value]="parada.id">{{ parada.localParada || parada.descricao }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      }

      <mat-form-field class="input-tg w-full" appearance="outline">
        <mat-label>Observação</mat-label>
        <textarea matInput formControlName="observacao"></textarea>
      </mat-form-field>

      <div class="flex gap-2">
        <mat-form-field class="input-tg w-1/2" appearance="outline">
          <mat-label>Data ocorrido (registro offline)</mat-label>
          <input matInput [matDatepicker]="dataOcorrido" formControlName="dataOcorrido" />
          <mat-datepicker-toggle matSuffix [for]="dataOcorrido"></mat-datepicker-toggle>
          <mat-datepicker #dataOcorrido></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="input-tg w-1/2" appearance="outline">
          <mat-label>Hora ocorrido</mat-label>
          <input matInput type="time" formControlName="horaOcorrido" />
        </mat-form-field>
      </div>

      <div class="flex justify-end">
        <button mat-flat-button class="btn-tg" [disabled]="form.invalid || saving" (click)="salvarManual()">
          @if (saving) {
          <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
          } @else {
          Registrar etapa
          }
        </button>
      </div>
    </div>
  </div>
</div>
